var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{attrs:{"flat":""}},[_c('q-card-section',[_c('SelectDateRange',{attrs:{"visible-comment":false},on:{"date-range-selected":_vm.loadReport}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }